import axios from 'axios'
import { CONTENT_TYPES } from 'utils/constants'

import BaseProxy from './BaseProxy'

export class ChampionshipsProxy extends BaseProxy {
  async get(slugUrlOrId) {
    const response = await axios.get(`${this._baseUrl}/championships/${slugUrlOrId}`)
    return response.data
  }

  async post(championship) {
    const response = await axios.post(`${this._baseUrl}/championships`, championship)
    return response.data
  }

  async put(id, championship) {
    const response = await axios.put(`${this._baseUrl}/championships/${id}`, championship)
    return response.data
  }

  async putLike(id) {
    const response = await axios.put(`${this._baseUrl}/championships/${id}/like`)
    return response.data
  }

  async putDisLike(id) {
    const response = await axios.put(`${this._baseUrl}/championships/${id}/un-like`)
    return response.data
  }

  async putImage(id, file) {
    const formData = new FormData()
    formData.append('file', file)

    const response = await axios.put(`${this._baseUrl}/championships/${id}/image`, formData, {
      headers: {
        'Content-Type': CONTENT_TYPES.MULTIPART_FORM_DATA
      }
    })

    return response.data
  }

  async deleteImage(id) {
    const response = await axios.delete(`${this._baseUrl}/championships/${id}/image`)
    return response.data
  }

  async getResults(id) {
    const response = await axios.get(`${this._baseUrl}/championships/${id}/results`)
    return response.data
  }

  async postEventCircuitCategoryResults(id, eventIds) {
    const response = await axios.post(
      `${this._baseUrl}/championships/${id}/event-circuit-category-results`,
      { eventIds }
    )

    return response.data
  }
}
